import { Platform } from 'react-native';

import { getEnvVars } from '@order/utils';

// ─────────────────────────────────────────────────────────────────────────────

const { APPSFLYER_APP_ID_IOS, APPSFLYER_APP_ID_ANDROID, APPSFLYER_API_KEY } = getEnvVars();

export const appsFlyerConfig = {
  appId: Platform.OS === 'ios' ? APPSFLYER_APP_ID_IOS : APPSFLYER_APP_ID_ANDROID,
  devKey: APPSFLYER_API_KEY,
  isDebug: false,
  onInstallConversionDataListener: true,
  onDeepLinkListener: true,
  timeToWaitForATTUserAuthorization: 10,
};
